var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"resetPasswordWrap"},[_c('v-card',{staticClass:"mx-auto mt-10",attrs:{"max-width":"600px"}},[_c('v-card-text',[_c('ResetPassword',{attrs:{"token":_vm.token}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }